import { create } from "zustand";
import type { User, UserLevel } from "./types";

interface AuthState {
  user: User | null;
  previewLevel: UserLevel | null;
  setUser: (u: User | null) => void;
  setPreviewLevel: (l: UserLevel | null) => void;
}

// `user` is always the real acting user. `previewLevel`, when set,
// overrides the level for permission checks throughout the UI so
// supervisors can preview what each level's view looks like without
// actually switching identity. Writes still happen as the real user.
export const useAuth = create<AuthState>((set) => ({
  user: null,
  previewLevel: null,
  setUser: (user) => set({ user }),
  setPreviewLevel: (previewLevel) => set({ previewLevel }),
}));

// Effective user: the real user with `level` replaced when previewing.
// Pages should call this instead of reading `user` directly when doing
// permission checks.
export function useEffectiveUser(): User | null {
  return useAuth((s) => {
    if (!s.user) return null;
    if (s.previewLevel) return { ...s.user, level: s.previewLevel };
    return s.user;
  });
}
